import { Component, effect, signal } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import { Ballot } from 'src/app/ballot/backend-types';
import { BallotListService } from 'src/app/ballot-list/ballot-list.service';
import { Router } from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import { ballotRoute } from '../../route-names';
import { ElectionsItemComponent } from './elections-item/elections-item.component';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatBadgeModule } from '@angular/material/badge';
import { ApiAboutService } from 'src/app/Services/api-about.service';
import { ElectorDataService } from 'src/app/Services/elector-data.service';


@Component({
    selector: 'app-elections-panel',
    imports: [MatExpansionModule, MatIconModule, ElectionsItemComponent, MatBadgeModule],
    templateUrl: './elections-panel.component.html',
    styleUrl: './elections-panel.component.scss'
})
export class ElectionsPanelComponent {
  events: Ballot[] = [];
  eventsCount: number = 0;
  eventsOpenState = signal(false);
  
  constructor(
    private aboutService: ApiAboutService,
    private readonly listService: BallotListService,
    private readonly router: Router,
    private readonly userService: ElectorDataService,
    private announcer: LiveAnnouncer
  ) {

    effect(() => {
      this.events = listService.getBallots().filter((event) => event.eventType?.toLowerCase().includes("election")) ?? [];
      this.eventsCount = this.events.length;
    })
  }

  selectedBallot(selectedEventId: number): void {
    let index = this.events.findIndex((ballot) => (ballot.eventId === selectedEventId));
    if(index < 0){
      console.error("Missing ballot!");
      return;
    }
    this.aboutService.headerImageUrl.set(this.userService.getImageUrlForEventOrOrg(selectedEventId));
    this.aboutService.headerTitle.set(this.events[index].voteEventData.description);
    this.aboutService.headerDates.set(this.listService.formatDateRange(this.events[index]));
    this.aboutService.setElectionStartAndClose(this.events[index].eventActivation, this.events[index].eventExpiration);
    this.listService.setBallotService(this.listService.getOverallIndexForEventID(selectedEventId));
    this.router.navigate(ballotRoute);
  }

  onPanelOpen(): void {
    this.eventsOpenState.set(true);
    this.announcer.announce('You have '+ this.eventsCount + ' elections available.', "assertive")
  }

  onPanelClose(): void {
    this.eventsOpenState.set(false);
    this.announcer.announce('Click to view your available elections.' , "assertive")
  }
  get openDescriptionBallot(): string {
    return $localize`Select a ballot to begin making selections.`;
  }

  get closeDescriptionBallot(): string {
    return $localize`Click here to view your available ballots.`;
  }

  get EventsOpenStateDescription(): string {
    return $localize`Click to view your available elections.`;
  }

  numBallots(): number {
    return this.events.filter(b => this.listService.isActionable(b)).length;
  }

  areNoBallots(): boolean {
    return this.numBallots() == 0;
  }
}
